import React, { useEffect, useState } from 'react'

import { Header } from '../../components/header/header'
import { NavBar } from '../../components/navBar/navbar'
import { Menu } from '../../components/menu/menu.jsx'
import LoadContainer from '../../components/loading'

import { getContratos } from '../../services/api'
import { Modal } from '../../components/modal'

import './styles.css'
import Contract from './contract'
import { getProjectsCookies } from '../../services/updateData'

const Contracts = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [contracts, setContracts] = useState([])
	let check = false

	const askForProcessos = async () => {
		setIsLoading(true)
		const projects = await getProjectsCookies()
		projects.map(async (project) => {
			const processosResponse = await getContratos(project.id)
			const contractInfo = {
				project_name: project.name,
				signature_date: processosResponse.data.signature_date,
				demand_object: processosResponse.data.demand_object,
				status: processosResponse.data.status,
				project_id: processosResponse.data.project_id,
			}
			setContracts((prev) => [...prev, contractInfo])
		})
		setIsLoading(false)
	}
	const goHome = () => {
		window.location.href = '/home'
	}
	useEffect(() => {
		if (!check) {
			askForProcessos()
			check = true
		}
	}, [])

	return (
		<div id="contracts">
			<Modal></Modal>
			<div className="column">
				<NavBar></NavBar>
				<Menu></Menu>
				<Header></Header>
				{isLoading ? <LoadContainer></LoadContainer> : ''}
				<div className="main-contracts">
					<span className="material-symbols-outlined goback" onClick={goHome}>
						arrow_back
					</span>
					<h1 className="contracts-title">Contratos</h1>
					<div className="contractsContainer">
						{contracts.length > 0 ? (
							contracts.map((contract, index) => <Contract key={index} contract={contract} />)
						) : (
							<>
								<br />
								<br />
								<span>Sem contratos disponíveis.</span>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default Contracts
